import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { fetchSliderGroupGet } from '../../redux/slices/sliderGroupGetSlice'
import { fetchSliderGroupCreate } from '../../redux/slices/sliderGroupCreateSlice'
import { fetchSliderGroupUpdate } from '../../redux/slices/sliderGroupUpdateSlice'

const CrudSliderGroup = ({ showMenu, setShowMenu, setChanged, setSelectedItem, selectedItem, t }) => {
  const [formData, setFormData] = useState({ files: [] })
  const dispatch = useDispatch()

  const getData = async () => {
    if (selectedItem !== 0) {
      var data = await dispatch(fetchSliderGroupGet({ id: selectedItem }))
      if (data.payload) {
        setFormData({
          files: data.payload?.files,
          titletr: data.payload?.title["tr"],
          titleen: data.payload?.title["en"],
        })
      }
    }
  }

  const closeModal = () => {
    setFormData({ files: [], titletr: "", titleen: "" })
    setShowMenu(!showMenu)
    setSelectedItem(0)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const title = { "tr": formData.titletr, "en": formData.titleen }
    const description = {}
    const content = {}

    const filesToKeep = formData.files
      .filter(file => typeof file === 'string' || !file.file)
      .map(file => typeof file === 'string' ? file : file.preview);

    const newFiles = formData.files.filter(file => file.file);

    await dispatch(
      selectedItem === 0 ?
        fetchSliderGroupCreate({ file: formData.files, title: title, description: description, content: content }) :
        fetchSliderGroupUpdate({ id: selectedItem, filesToKeep: filesToKeep, file: formData.files, title: title, description: description, content: content })
    )
    closeModal()
    setChanged(true)
    getData()
    setShowMenu(false)
  }

  useEffect(() => { getData() }, [dispatch, selectedItem])

  return (
    <div className={showMenu ? 'right-popup' : 'd-none'}>
      <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
      <div className='right-popup-menu'>
        <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "slider_group_add" : "slider_group_edit")}</h5></div>
        <Form onSubmit={handleSubmit}>
          <FormItem
            id={`titletr`}
            name={`titletr`}
            type="text"
            icon={<MdTitle size={20} />}
            title={`${t("title")} (TR)`}
            formData={formData}
            setFormData={setFormData}
            keyT='titletr'
          />
          <FormItem
            id={`titleen`}
            name={`titleen`}
            type="text"
            icon={<MdTitle size={20} />}
            title={`${t("title")} (EN)`}
            formData={formData}
            setFormData={setFormData}
            keyT='titleen'
          />

          <div className='d-flex justify-content-end mt-4 w-100'>
            <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
              {t(selectedItem === 0 ? "add" : "edit")}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default CrudSliderGroup